import React from 'react';
import Descriptions from 'antd/es/descriptions';
import { AuthenticatedContextType } from '../../context/AuthenticatedContext';
import {
  contentHeight100,
  contentStyle,
  dataDispWidth,
  labelStyle,
  userContentStyle,
  userLabelStyle,
} from '../../css/style';
import { dateformat } from '../date-range';
import EqCset from '../../models/data/EqCset';

interface DataProps {
  userdata: AuthenticatedContextType;
  data: EqCset | undefined;
}

const DataDisp: React.FC<DataProps> = ({ userdata, data }) => {
  const customerName = userdata.loginCustomer?.customerName ?? '';
  const corporateCode = userdata.loginCustomer?.corporateCode ?? '';

  return (
    <div>
      {/* ユーザ情報 */}
      <Descriptions
        bordered
        column={1}
        labelStyle={userLabelStyle}
        contentStyle={userContentStyle}
        style={{ marginBottom: '10px', width: dataDispWidth.userInfo }}
      >
        <Descriptions.Item label="ユーザ名" span={1}>
          {`${corporateCode} ◇ ${customerName}`}
        </Descriptions.Item>
      </Descriptions>
      {/* ID */}
      <Descriptions
        bordered
        column={1}
        contentStyle={contentStyle}
        labelStyle={labelStyle}
        style={{ marginBottom: '10px', width: dataDispWidth.eqCsetDetail }}
      >
        <Descriptions.Item label="設備ID" span={1}>
          {data?.cSetCustEqId ?? ''}
        </Descriptions.Item>
        <Descriptions.Item label="改造移設ID" span={1}>
          {data?.cSetId ?? ''}
        </Descriptions.Item>
      </Descriptions>
      {/* 改造移設撤去詳細 */}
      <Descriptions
        bordered
        column={1}
        contentStyle={contentStyle}
        labelStyle={labelStyle}
        style={{ marginBottom: '10px', width: dataDispWidth.eqCsetDetail }}
      >
        <Descriptions.Item label="分類" span={1}>
          {data?.cSetType ?? ''}
        </Descriptions.Item>
        <Descriptions.Item label="工号" span={1}>
          {data?.cSetjobNo ?? ''}
        </Descriptions.Item>
        <Descriptions.Item label="件名" span={1}>
          {data?.cSetName ?? ''}
        </Descriptions.Item>
        <Descriptions.Item
          label="内容"
          span={1}
          contentStyle={{ ...contentStyle, ...contentHeight100 }}
        >
          {data?.cSetSummary ?? ''}
        </Descriptions.Item>
        <Descriptions.Item label="実施年月日" span={1}>
          {dateformat(data?.cSetDate)}
        </Descriptions.Item>
      </Descriptions>
    </div>
  );
};

export default DataDisp;
